var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFitclubIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 90,
    viewBox: "0 0 85 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    width: 79,
    height: 80,
    rx: 18,
    fill: "#FF5A5F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5312_12731)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.7001 28.2C46.7001 24.2235 49.8833 21 53.8101 21C57.7368 21 60.9201 24.2235 60.9201 28.2C60.9201 32.1765 57.7368 35.4 53.8101 35.4C52.4188 35.4 51.1209 34.9953 50.0248 34.2959L45.7745 38.6L50.6194 43.5062C51.129 44.0223 51.9111 44.1185 52.5224 43.763L52.6846 43.6548L56.8121 40.52C57.5102 39.9898 58.5005 40.1331 59.0241 40.84C59.5074 41.4925 59.424 42.3973 58.8592 42.9496L58.7081 43.08L54.5806 46.2148C52.7756 47.5857 50.2811 47.4714 48.6078 45.9807L48.3849 45.7689L43.5401 40.8627L27.2773 57.3314C26.6603 57.9562 25.6599 57.9562 25.0428 57.3314C24.4733 56.7546 24.4295 55.847 24.9114 55.2194L25.0428 55.0686L42.4216 37.4699C42.422 37.4695 42.4224 37.469 42.4228 37.4686C42.4233 37.4682 42.4237 37.4678 42.4241 37.4674L47.7904 32.0332C47.0997 30.9232 46.7001 29.6089 46.7001 28.2ZM57.7601 28.2C57.7601 25.9909 55.9916 24.2 53.8101 24.2C51.6286 24.2 49.8601 25.9909 49.8601 28.2C49.8601 30.4091 51.6286 32.2 53.8101 32.2C55.9916 32.2 57.7601 30.4091 57.7601 28.2ZM33.5211 29.4872C35.0354 29.1038 36.6319 29.5011 37.7956 30.5346L38.0224 30.7498L39.9173 32.6686C40.5343 33.2935 40.5343 34.3065 39.9173 34.9314C39.3477 35.5081 38.4515 35.5525 37.8317 35.0645L37.6828 34.9314L35.788 33.0125C35.4446 32.6648 34.9656 32.499 34.4905 32.5543L34.2875 32.5917L29.7033 33.7522C28.8567 33.9665 27.9989 33.4453 27.7873 32.5881C27.5907 31.792 28.0205 30.9861 28.7607 30.7035L28.9369 30.6478L33.5211 29.4872ZM44.5085 46.9355C43.8886 46.4475 42.9924 46.4919 42.4228 47.0686C41.8058 47.6935 41.8058 48.7065 42.4228 49.3314L43.5474 50.4702L43.6789 50.6209C44.1608 51.2486 44.117 52.1561 43.5474 52.7329C43.374 52.9086 43.1625 53.0409 42.9298 53.1194L38.3004 54.6821L38.129 54.7513C37.4124 55.0906 37.0449 55.9275 37.3012 56.706C37.5771 57.5443 38.4719 57.9973 39.2997 57.7179L43.9291 56.1552L44.2726 56.0241C44.8355 55.7836 45.3483 55.4348 45.7819 54.9957C47.633 53.1211 47.633 50.082 45.7819 48.2074L44.6573 47.0686L44.5085 46.9355Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5312_12731",
    x: -1,
    y: 5,
    width: 85.9199,
    height: 86.4004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.228155 0 0 0 0 0 0 0 0 0.48 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5312_12731"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5312_12731",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitclubIcon);
export default __webpack_public_path__ + "static/media/fitclub-icon.cdd02230d68e46e3a5684dda57adedc3.svg";
export { ForwardRef as ReactComponent };